module.exports = __webpack_public_path__ + "img/10551387_L.09249924.png";